<template>
<div class="chapter">
<div class="inner_page">
<div id="x9781590207048-3.html" xml:lang="en-US">
<div class="Basic-Text-Frame" style="margin: 15%;">
<p class="Dedication-Text" id="toc_marker-4">To A.<br/>J.<br/>M.<br/>and a “four”</p>
<p class="Dedication-Text">without any of whom, <br/>no book.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781590207048-3.vue?5ce61181